module.exports = __webpack_public_path__ + "img/map.0bb70dd2.svg";